import React from 'react';
import { FreestarAd } from './Freestar/FreestarAd';

export const DefaultAdHeader: React.FC = () => {
  return (
    <div className="w-full flex items-center justify-center">
      <FreestarAd className="overflow-hidden h-full" placement="top_header" />
    </div>
  );
};
